import { BrandVehicleModel } from '@app/src/views/StepOne/form/models/brandVehicle';
import { BrandVehicleDTO } from '@app/src/views/StepOne/form/dtos';

export const hydrateData = (data: BrandVehicleDTO[]) => data.map((item) => ({
  name: item.name,
  alias: item.alias,
  top: item.top,
  state: item.state,
  adecsysId: item.adecsys_id,
  id: item.id
})) as BrandVehicleModel[];
